<template>
  <div class="point_error">
    <section class="text_center">
      <h2 class="header_underline">クレジット決済キャンセル</h2>
      <p class="point_error_notice">クレジット決済をキャンセルしました。</p>
      <p>
        <router-link :to="{ name: 'PointCreditForm', params: { paymentWay: paymentWay } }" class="arrow link_main--text">ポイント購入ページに戻る</router-link>
      </p>
    </section>
  </div>
</template>

<script>
export default {
  name: 'PointCreditCancel',
  data () {
    return {
      paymentWay: this.$route.params.paymentWay
    }
  }
}
</script>
